var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}cancel-24`,"viewBox":"0 0 24 24"}},[_c('circle',{staticClass:"base",attrs:{"cx":"12","cy":"12","r":"12"}}),_c('g',{staticClass:"sign"},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"6","stroke-width":"2"}}),_c('path',{attrs:{"d":"M15 8L9 16","stroke-width":"2"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }